
const prod = {
    url: {

        FILE_UPLOAD_URL: "https://api.apdsc.apcfss.in/dscdms/user-defined-path/file-upload/bucket/documents.apdsc.apcfss.in/",
        FILE_VIEW_URL: "https://api.apdsc.apcfss.in/dscdms/user-defined-path/file-download/bucket/documents.apdsc.apcfss.in/",
        FILE_DOWNLOAD_URL: "https://api.apdsc.apcfss.in/dscdms/user-defined-path/file-download/bucket/documents.apdsc.apcfss.in/",
        status: 'prod',
        frontend_url: 'kgbvrecruitment.apcfss.in',
        // frontend_url: 'apdsc.apcfss.in',
        CONTEXT_URL: 'https://api.apdsc.apcfss.in/apdscapi/', //NOSONAR
        CONTEXT_DEPT_URL: 'https://api.apdsc.apcfss.in/apdscdeptapi/', //NOSONAR
        CONTEXT_READ_URL: 'https://api.apdsc.apcfss.in/apdscreadapi/', //NOSONAR
    }
};
const local = {
    url: {
        CONTEXT_URL: 'http://172.16.118.194:8083/kgbvrecruitmentapi/', //NOSONAR
        CONTEXT_DEPT_URL: "http://172.16.118.46:8082/apdscdeptapi/",//NOSONAR
        CONTEXT_READ_URL: 'http://172.16.118.194:8084/kgbvrecruitmentreadapi/', //NOSONAR
        FILE_UPLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/",
        FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        FILE_VIEW_URL: "https://api.apdsc.apcfss.in/dscdms/user-defined-path/file-download/bucket/documents.apdsc.apcfss.in/",
        status: 'local'
    }
};
const dev = {
    url: {
        FILE_UPLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/",
        // FILE_VIEW_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/bucket/documents.apdsc.apcfss.in/",
        // FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        FILE_DOWNLOAD_URL:"https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        FILE_VIEW_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        CONTEXT_URL: 'https://swapi.dev.nidhi.apcfss.in/kgbvrecruitmentapi/',
        CONTEXT_DEPT_URL: "https://swapi.dev.nidhi.apcfss.in/kgbvrecruitmentreadapi/",
        CONTEXT_READ_URL: 'https://swapi.dev.nidhi.apcfss.in/kgbvrecruitmentreadapi/',//NOSONAR
        frontend_url: 'kgbvrecruitment.dev.nidhi.apcfss.in',
        status: 'dev'
    }
};
const test = {
    url: {
        FILE_DOWNLOAD_URL: "https://api.apdsc.apcfss.in/dscdms/user-defined-path/file-download/bucket/documents.apdsc.apcfss.in/",

        FILE_UPLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/",
        FILE_VIEW_URL: "https://api.apdsc.apcfss.in/dscdms/user-defined-path/file-download/bucket/documents.apdsc.apcfss.in/",
        // FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        CONTEXT_URL: 'https://swapi.test.nidhi.apcfss.in/apdscapi/',
        CONTEXT_READ_URL: 'https://swapi.test.nidhi.apcfss.in/apdscreadapi/', //NOSONAR
        frontend_url: 'apdsc.test.nidhi.apcfss.in',
        status: 'test'
    }
};
const hostname = window.location.hostname
export const config = (() => {
    if (process.env.NODE_ENV === 'production' && hostname === prod.url.frontend_url) {
        return prod;
    } else if (process.env.NODE_ENV === 'production' && hostname === dev.url.frontend_url) {
        return dev;
    }
    else if (process.env.NODE_ENV === 'development') {
        return dev;
    }
    else {
        return dev
    }
})();

